import cx from 'classnames';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import useLinkProps, { originalRoutes } from '../../../hooks/use-link-props';
import { useAppContext } from '../../providers/app-context';
import Switch from '../../ui/switch';

type ShippingCostInfoProps = {
  productDetail?: TProductDetail;
  shippingCostVisible?: boolean;
  justifyCenter?: boolean;
  iconSide?: 'left' | 'right';
};

const ShippingCostInfo = ({
  productDetail,
  shippingCostVisible = false,
  justifyCenter = false,
  iconSide = 'left',
}: ShippingCostInfoProps) => {
  const { t } = useTranslation();
  const {
    pathname,
    push,
    query: { detail_prices, ...query },
  } = useRouter();
  const { detailedPrice } = useAppContext();
  const getLink = useLinkProps();
  const showShipping =
    typeof detailedPrice === 'boolean' ? detailedPrice : false;
  const key = Object.entries(originalRoutes).find(
    ([, value]) => value === pathname
  )?.[0];
  const link = getLink(key as keyof typeof originalRoutes, query);

  if (typeof detailedPrice !== 'boolean') return null;

  return (
    <div className="flex flex-row items-end justify-between gap-3">
      <div
        className={cx(
          'flex gap-[12px]',
          justifyCenter
            ? 'justify-center'
            : iconSide === 'left'
              ? 'justify-end'
              : 'justify-start',
          iconSide === 'left' ? 'flex-row' : 'flex-row-reverse'
        )}
      >
        <Switch
          isActive={showShipping}
          onClick={(status) => {
            Cookies.set('detail_prices', (status).toString(), {
              expires: new Date(Date.now() + 1000 * 60 * 60 * 24),
            });
            setTimeout(() => {
              push(link.href, link.as);
            }, 0);
          }}
        />
        <button className="text-base leading-4 font-bold flex items-end">
          {t('products:detail-price.shipping-price')}
        </button>
      </div>
      {shippingCostVisible &&
        showShipping &&
        productDetail?.pricing?.details?.shipping_in_currency_printable && (
          <div className="flex gap-4 justify-end">
            <div className="text-[14px] leading-3 text-neutral-80 font-bold">
              {productDetail?.pricing?.details?.shipping_in_currency_printable}
              <div>
                {
                  productDetail?.pricing?.details
                    ?.shipping_in_default_currency_printable
                }
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default ShippingCostInfo;
